<div class="horizontal-sidebar p-y-8 b-t-1" *ngIf="mobileQuery.matches">
  <div class="horizontal-navbar hstack align-items-center justify-content-center w-100">
    <ng-container *ngFor="let item of filteredNavItems;">
      <app-horizontal-nav-item [item]="item" class="parentBox {{ item.ddType }}" [ngClass]="{
          pactive: item.route == parentActive ? 'pactive' : ''
        }"></app-horizontal-nav-item>
    </ng-container>
    <div class="search-container search-container--menu">
      <app-search-list
        [menuBar]="true"
        [vista]="searchConfig.view"
        [value_id]="searchConfig.value"
        [nameFields]="searchConfig.dataNames"
        (handleEditChanges)="handleSearchSelection($event)">
      </app-search-list>
    </div>
  </div>
</div>